import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export const quizStepSlice = createSlice({
    name: 'initial-quiz',
    // initial session state as SessionDataI interface model
    initialState: {
        currentStep: 0,
    },
    reducers: {
        /**
         * @param current state
         * @param action payload with new data to update state
         */
        setStep: (state, action: PayloadAction<{ step: number }>) => {
            state.currentStep = action.payload.step;
        },
        // user log out
        incrementStep: (state, action: PayloadAction<{ step: number }>) => {
            state.currentStep = state.currentStep + action.payload.step;
        },
    },
});

export const { setStep, incrementStep } = quizStepSlice.actions;
export default quizStepSlice.reducer;
